import { CustomIconProps } from './index';

export const CopyIcon = ({ color }: CustomIconProps) => {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle
                cx={12}
                cy={12}
                r={11}
                fill="#fff"
                stroke={color || 'black'}
                strokeWidth={2}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 6H5v10h4v3h9V9h-4V6H7zm5 2H7v6h5V8zm2 3h2v6h-5v-1h3v-5z"
                fill={color || 'black'}
            />
        </svg>
    );
};
